import { render } from "./my_purchases.vue?vue&type=template&id=2aa82826&scoped=true"
import script from "./my_purchases.vue?vue&type=script&lang=js"
export * from "./my_purchases.vue?vue&type=script&lang=js"

import "./my_purchases.vue?vue&type=style&index=0&id=2aa82826&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa82826"]])

export default __exports__